/**
 * Product ID Composable
 *
 * Provides safe access to global productId variable populated by the backend (Pimcore/Symfony).
 *
 * Usage:
 * ```ts
 * import { loadProductId } from '@/composables/offers/useProductId';
 *
 * const productId = loadProductId();
 * if (productId) {
 *   console.log('Product ID:', productId);
 * }
 * ```
 */

declare const productId: string | undefined;

export function loadProductId(): string | null {
  if (typeof productId === 'undefined') {
    return null;
  }

  if (typeof productId === 'string' && productId.trim().length > 0) {
    return productId.trim();
  }

  return null;
}
